import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { Pin, Tag } from "lucide-react";
import Navigation from "../components/Navigation";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function TopicsPage({ user }) {
  const [topics, setTopics] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const resp = await axios.get(`${API}/topics`);
        setTopics(resp.data.topics || []);
      } catch {
        setTopics([]);
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  return (
    <div className="min-h-screen bg-sky-50">
      <Navigation user={user} />
      <main className="max-w-5xl mx-auto px-4 sm:px-6 py-10" data-testid="topics-page">
        <h1 className="text-4xl sm:text-5xl font-bold text-slate-900" style={{ fontFamily: "Fraunces, serif" }}>
          Browse Research Topics
        </h1>
        <p className="mt-4 max-w-3xl text-slate-600 leading-7">
          Explore The Archive's most active research topics in engineering, extractive metallurgy, mining,
          hydrometallurgy, industrial chemistry, and applied science. Each topic page gathers the books, journal
          articles, theses, and technical reports on that subject from the 2RA-Edition digital library — searchable
          in full text and readable online.
        </p>

        {loading ? (
          <div className="text-center py-16 text-slate-500">Loading topics…</div>
        ) : topics.length === 0 ? (
          <div className="text-center py-16 text-slate-500">No topics available yet.</div>
        ) : (
          <div className="mt-8 grid sm:grid-cols-2 lg:grid-cols-3 gap-4" data-testid="topics-grid">
            {topics.map((topic) => (
              <Link
                key={topic.slug}
                to={`/topics/${topic.slug}`}
                className="bg-white border border-slate-200 rounded-lg p-5 hover:border-orange-300 hover:shadow-sm transition-all group"
                data-testid={`topic-card-${topic.slug}`}
              >
                <div className="flex items-start justify-between gap-3">
                  <h2 className="font-semibold text-slate-900 group-hover:text-orange-600 transition-colors capitalize" style={{ fontFamily: "Fraunces, serif" }}>
                    {topic.name}
                  </h2>
                  {topic.pinned
                    ? <Pin className="w-4 h-4 text-orange-500 shrink-0 mt-1" data-testid={`topic-pinned-${topic.slug}`} />
                    : <Tag className="w-4 h-4 text-orange-400 shrink-0 mt-1" />}
                </div>
                <p className="text-sm text-slate-500 mt-2">{topic.count} document{topic.count === 1 ? "" : "s"}</p>
              </Link>
            ))}
          </div>
        )}
      </main>
    </div>
  );
}
